export default __webpack_public_path__ + "static/media/DashboardIcon.ecdd48d4.svg";